
document.addEventListener('DOMContentLoaded', function () {
    const variantData = JSON.parse(document.getElementById('variant-data').textContent);

    let isSyncing = false;

    const purchaseRadios = document.querySelectorAll('.purchase-options [name="purchase"]');

    purchaseRadios.forEach((radio) => {
        radio.addEventListener('click', function (e) {
            if (!e.isTrusted || isSyncing) return;

            isSyncing = true;

            const purchaseValue = this.value;
            console.log('purchaseValue....', purchaseValue);

            const trySync = () => {
                const widget = document.querySelector('recharge-subscription-widget');
                if (!widget || !widget.shadowRoot) {
                    setTimeout(trySync, 200);
                    return;
                }

                const root = widget.shadowRoot;

                const subscriptionRadio = root.querySelector(`input[value="${purchaseValue}"]`);
                if (!subscriptionRadio) {
                    setTimeout(trySync, 200);
                    return;
                }

                subscriptionRadio.click();

                if (purchaseValue === 'onetime') {
                    isSyncing = false;
                    return;
                }

                const sellingPlans = root.querySelector('rc-selling-plans');
                if (!sellingPlans || !sellingPlans.shadowRoot) {
                    setTimeout(trySync, 200);
                    return;
                }

                const frequencyInput = document.querySelector('.purchase-options .frequency input:checked');
                if (!frequencyInput) {
                    isSyncing = false;
                    return;
                }

                const selling_group_id = frequencyInput.getAttribute('selling-group-id');

                const allocation = variantData.variant.selling_plan_allocations
                    .find(a => a.selling_plan_group_id === selling_group_id);

                if (!allocation) {
                    isSyncing = false;
                    return;
                }

                const planRadio = sellingPlans.shadowRoot.querySelector(
                    `input[name="rc_plan"][value="${allocation.selling_plan_id}"]`
                );

                if (planRadio) {
                    planRadio.click();
                }

                isSyncing = false;
            };

            trySync();
        });
    });

    const frequencyRadios = document.querySelectorAll('.purchase-options .frequency input[type="radio"]');
    frequencyRadios.forEach(function (radio) {
        radio.addEventListener('change', function () {
            const selling_group_id = this.getAttribute('selling-group-id');
            if (!selling_group_id) return;

            const allocation = variantData.variant.selling_plan_allocations.filter(allocation => allocation.selling_plan_group_id === selling_group_id);
            const selling_plan_id = allocation[0].selling_plan_id;

            const widget = document.querySelector('recharge-subscription-widget');
            if (!widget || !widget.shadowRoot) return;
            const root = widget.shadowRoot;

            const sellingPlans = root.querySelector('rc-selling-plans');
            if (!sellingPlans || !sellingPlans.shadowRoot) return;
            const planRadio = sellingPlans.shadowRoot.querySelector(`input[name="rc_plan"][value="${selling_plan_id}"]`);

            if (planRadio) {
                planRadio.click();
            }

            const oldPrice = this.getAttribute('old-price');
            const newPrice = this.getAttribute('new-price');
            const oldPriceElement = document.querySelector('.purchase-options .po-price .old');
            oldPriceElement.innerText = oldPrice;
            const newPriceElement = document.querySelector('.purchase-options .po-price .new');
            newPriceElement.innerText = newPrice;
        });
    });
})
